/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DataMapper } from '@gh/core-data';
import { arrayIterator } from '@gh/core-util';
import { Table, TableCreatorOp, TableFindAllOp } from './table.interfaces';

export function createTableMapper<T>(createOp: TableCreatorOp<T>,
                                     findAllOp: TableFindAllOp<T>,
                                     entityMapper: DataMapper<T, any>): DataMapper<Table<T>, any> {
  class TableDataMapper implements DataMapper<Table<T>, any> {

    serialize(table: Table<T>): any {
      return findAllOp(table).map((row) => entityMapper.serialize(row));
    }

    deserialize(json: any): Table<T> {
      if (json) {
        return createOp(arrayIterator(json.map((jsonItem: any) => entityMapper.deserialize(jsonItem))));
      } else {
        return createOp();
      }
    }
  }

  return new TableDataMapper();
}
